import { object, func, oneOfType, string } from 'prop-types'

const appearance = string

const Icon = oneOfType([func, object])

const size = string

export { appearance, Icon, size }
